import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { Box } from "@material-ui/core";
import { UserGroup } from "../model/user";
import { Unauthorized } from "./Unauthorized";

const Home = (): JSX.Element => {
  const userGroups = useSelector((state: any) => state.userGroups.userGroups);

  return (
    <Box>
      {userGroups.length === 0 && <Unauthorized />}
      {userGroups?.length === 1 && userGroups?.includes(UserGroup.WAREHOUSE_PERSONNEL_GROUP) && <Redirect to="/list" />}
    </Box>
  );
};

export default Home;
